import AuditLogList from "./AuditLogList";

export default AuditLogList;
